import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "contact-details-tab position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title" }, "Your contact details", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 item-label-alt" }, " Any updates to your contact details will be updated in your mybooster account. ", -1)
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = { class: "px-0 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "item-label mb-3" }, "Postal address", -1)
const _hoisted_7 = { class: "row col-12 mb-3 ms-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  for: "postal-same",
  class: "col-10 item-body me-2 align-self-center"
}, "Postal address is the same as my home address", -1)
const _hoisted_9 = { class: "row col-12 ms-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  for: "postal-different",
  class: "col-10 item-body me-2 align-self-center"
}, "Postal address is different", -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "bg-info text-white p-2 mb-2 rounded" }
const _hoisted_13 = { class: "row overflow-x-hidden" }
const _hoisted_14 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 center-btn" }
const _hoisted_15 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12 text-end center-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_TextInputSmall = _resolveComponent("TextInputSmall")!
  const _component_AddressDetails = _resolveComponent("AddressDetails")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    (_ctx.insuredPerson?.addresses)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TextInputSmall, {
              value: _ctx.insuredPerson.mobile,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.insuredPerson.mobile) = $event)),
              title: 'Mobile',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('mobile')
            }, null, 8, ["value", "validation-error"]),
            _createVNode(_component_TextInputSmall, {
              value: _ctx.insuredPerson.workPhone,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.insuredPerson.workPhone) = $event)),
              title: 'Work phone',
              class: "px-0 mb-4 me-2",
              "validation-error": _ctx.readError('workPhone')
            }, null, 8, ["value", "validation-error"])
          ]),
          _createVNode(_component_AddressDetails, {
            value: _ctx.insuredPerson.addresses[0],
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.insuredPerson.addresses[0]) = $event)),
            "home-address": 'nativeAddress',
            errors: _ctx.errors['addresses[0]']
          }, null, 8, ["value", "errors"]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "postal-same",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isPostalAddressSame) = $event)),
                type: "radio",
                class: "col-2 form-check-input radio-check-booster-blue item-content",
                value: true
              }, null, 512), [
                [_vModelRadio, _ctx.isPostalAddressSame]
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                id: "postal-different",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isPostalAddressSame) = $event)),
                type: "radio",
                class: "col-2 form-check-input radio-check-booster-blue item-content",
                value: false
              }, null, 512), [
                [_vModelRadio, _ctx.isPostalAddressSame]
              ]),
              _hoisted_10
            ])
          ]),
          (!_ctx.isPostalAddressSame)
            ? (_openBlock(), _createBlock(_component_AddressDetails, {
                key: 0,
                value: _ctx.insuredPerson.addresses[1],
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.insuredPerson.addresses[1]) = $event)),
                "postal-address": 'nativeAddress',
                errors: _ctx.errors['addresses[1]']
              }, null, 8, ["value", "errors"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("hr", {
      class: _normalizeClass(["hr medium-bottom-spacing", {'d-none': _ctx.isMobileScreen}])
    }, null, 2),
    (_ctx.errorMsg && _ctx.errorMsg.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        (_ctx.previousPath)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["btn btn-booster-secondary float-start", {'d-none': _ctx.isMobileScreen}]),
              to: _ctx.previousPath
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            }, 8, ["class", "to"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.nextPath)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-booster-primary float-end",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToNextPage()))
            }, " Next "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}